import { render, staticRenderFns } from "./diriyah-gate-development.vue?vue&type=template&id=83d9af86&"
import script from "./diriyah-gate-development.vue?vue&type=script&lang=js&"
export * from "./diriyah-gate-development.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports